import { Link } from "react-router-dom";

const FOOTER_LINKS = [
  { to: "/founder", label: "Founder" },
  { to: "/philosophy", label: "Philosophy" },
  { to: "/craft", label: "Craft" },
  { to: "/journal", label: "Journal" },
  { to: "/join", label: "Join the List" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="max-w-7xl mx-auto px-6 md:px-10 py-12">
    <nav className="flex flex-wrap items-center gap-x-6 gap-y-3 mb-8">
      {FOOTER_LINKS.map((l) => (
        <Link
          key={l.to}
          to={l.to}
          data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
          className="text-[10px] md:text-xs font-medium tracking-[0.2em] uppercase text-[#2C241E]/55 transition-colors duration-200 hover:text-[#2C241E]"
        >
          {l.label}
        </Link>
      ))}
    </nav>
    <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t border-[#2C241E]/10 pt-8">
      <span className="text-sm font-medium tracking-[0.35em] uppercase text-[#2C241E]">LIGATEN</span>
      <p className="text-xs text-[#2C241E]/50">
        Crafted by a physiotherapist in Australia. © 2026 LIGATEN. All rights reserved.
      </p>
    </div>
  </footer>
);
